import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { MenuMensajeOption, OpcionTopNavigation } from '@/objects/Menus';
import TopNavigation from '@/components/elements/TopNavigation';
import Mensajes from './Mensajes';
import MensajesNotificaciones from './MensajesNotificaciones';

function MenuMensajes() {

    const [opcionActual, setOpcionActual] = useState<MenuMensajeOption>(MenuMensajeOption.MENSAJES);

    const { t } = useTranslation();

    const OpcionesBarraMenuMensajes: OpcionTopNavigation[] = [
        { nombre: t("menu:secciones.mensajes.titulo"), tipoOpcion: MenuMensajeOption.MENSAJES },
        { nombre: t("menu:secciones.mensajes.notificaciones"), tipoOpcion: MenuMensajeOption.NOTIFICACIONES },
    ];

    const setOpcionActualString = (opcion: string) => {
        setOpcionActual(opcion as MenuMensajeOption);
    }

    return (
        <section
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                minHeight: 0,
                overflow: 'hidden',
            }}
        >
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <TopNavigation
                opciones={OpcionesBarraMenuMensajes}
                opcionActual={opcionActual.toString()}
                setOpcionActual={setOpcionActualString}
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 5,
                    flexShrink: 0,
                }}
            />
            <section
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                {opcionActual === MenuMensajeOption.MENSAJES && <Mensajes />}
                {opcionActual === MenuMensajeOption.NOTIFICACIONES && <MensajesNotificaciones />}

            </section>
        </section>
    );
}

export default MenuMensajes;